
import HeaderLinks from "./HeaderLinks.vue";
import SearchDesktop from '@/components/Catalog/Search/SearchDesktop.vue';
export default {
    name: 'Header',
    components: {
        HeaderLinks,
        SearchDesktop
    },
    props: {
        links: {
            type: Object,
            default: undefined
        },
        search: {
            type: Object,
            default: undefined
        },
        logo: {
            type: Object,
            default: undefined
        },
    },
    data() {
        return {
            hideModals: false
        };
    },
    
    methods: {
        menuClick(){
            if(typeof VueEs6 !== 'undefined'){
                VueEs6.header.menu.hamburger();
            }    
        },
        menuOver(){
            if(typeof VueEs6 !== 'undefined'){
                VueEs6.header.menu.loadSubMenu();
            }    
        },
        clickSearch(value){
            this.hideModals = value;
        }
    },
};
